export default __webpack_public_path__ + "static/media/infoERP_Setup.8b9e0cf8.zip";